var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditorAddAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1181_1852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 4.6665L5.00001 7.99984H1.66667V12.9998H5.00001L9.16667 16.3332V4.6665Z",
    stroke: "#98BDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8917 4.6084C17.4539 6.17113 18.3315 8.29036 18.3315 10.5001C18.3315 12.7098 17.4539 14.829 15.8917 16.3917M12.95 7.55007C13.7311 8.33143 14.1699 9.39105 14.1699 10.4959C14.1699 11.6007 13.7311 12.6604 12.95 13.4417",
    stroke: "#98BDBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1181_1852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 0.5) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorAddAudio);
export default __webpack_public_path__ + "static/media/editor_add_audio.3d65d2b5a0df6c94d94287a6e91292e3.svg";
export { ForwardRef as ReactComponent };